var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0,
    fill: "currentColor",
    size: 20,
    width: 20,
    height: 20,
    style: {
      color: "var(--lmn-ds-colors-gray-800)",
      pointerEvents: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5V11.1C3.00001 19.0208 12 22 12 22C12 22 21 19 21 11.1V5L12 2L3 5ZM10.95 15.5501L16.6 9.9001L15.175 8.4751L10.95 12.7001L8.85005 10.6001L7.42505 12.0251L10.95 15.5501Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.2251f3824108c4af152fb3d4ac458283.svg";
export { ForwardRef as ReactComponent };